import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import ThemeContext from '../../../providers/ThemeProvider';

const Title = ({ headline, title, display, isProductPage }) => {
  const theme = useContext(ThemeContext);
  const ssr = useSelector((state) => state.deals.ssr);

  if (!display) {
    return null;
  }

  return (
    <>
      <div className="deal-main-deal__header">
        <h1 className="deal-main-deal__title">{headline}</h1>
        {!isProductPage && (
          <p
            className={classNames('deal-main-deal__subtitle', {
              visible: !ssr,
            })}
          >
            {title}
          </p>
        )}
      </div>
      <style jsx>{`
        .deal-main-deal__header {
          display: none;
          color: inherit;
          text-decoration: none;
          padding: 8px;
        }

        .deal-main-deal__title {
          font-size: 18px;
          width: calc(100% - 85px);
          margin-bottom: 16px;
        }

        .deal-main-deal__subtitle {
          visibility: hidden;
          margin-bottom: 0;
        }

        .deal-main-deal__subtitle.visible {
          visibility: visible;
        }

        .deal-main-deal__title {
          font-size: 22px;
        }

        @media (min-width: ${theme.breakpoints.smUp}) {
          .deal-main-deal__header {
            display: block;
          }

          .deal-main-deal__title {
            font-size: 22px;
            width: 100%;
            margin: 0;
          }
        }
      `}</style>
    </>
  );
};

Title.defaultProps = {
  display: true,
};

Title.propTypes = {
  display: PropTypes.bool,
  headline: PropTypes.string,
  isProductPage: PropTypes.bool,
  title: PropTypes.string,
};

export default Title;
